import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ProductPriceCurrencyRequest,
  ProductPriceCurrencyResponse
} from '../models/producto-price-currency.model';

@Injectable({
  providedIn: 'root'
})
export class ProductoPriceCurrencyApiService {
  private readonly apiUrl = `${environment.apiUrl}api/products`;

  constructor(private http: HttpClient) { }

  getProductPriceCurrencies(productId: number): Observable<ProductPriceCurrencyResponse[]> {
    return this.http.get<ProductPriceCurrencyResponse[]>(`${this.apiUrl}/${productId}/price-currencies`);
  }

  upsertProductPriceCurrency(productId: number, req: ProductPriceCurrencyRequest, businessId: number): Observable<ProductPriceCurrencyResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.post<ProductPriceCurrencyResponse>(`${this.apiUrl}/${productId}/price-currencies`, req, { params });
  }

  deleteProductPriceCurrency(productId: number, currencyId: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/${productId}/price-currencies/${currencyId}`, { params });
  }

  /**
   * Resuelve el precio del producto en una moneda destino.
   * El backend devuelve un número plano (Mono<BigDecimal>, ej. 85.00), no un objeto (Incidente #37).
   */
  resolveProductPriceCurrency(productId: number, currencyId: number): Observable<number> {
    const params = new HttpParams().set('currencyId', currencyId.toString());
    return this.http.get<number>(`${this.apiUrl}/${productId}/price-currencies/resolve`, { params });
  }
}
